<template>
    <div class="nopads">
        <!-- Header of collapsable item -->
        <div class="col-12 d-flex justify-content-between align-items-center pb-1">
            <div class="flex-grow-1">
                <h4 class="form-header pointer hover-header" @click.stop="reportsVisible = !reportsVisible">
                    {{ $t('danger_report.title') }} ({{dangerReports.length}})
                </h4>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner-section"
            />
            <div v-else class="ms-2 px-2" @click.stop="reportsVisible = !reportsVisible">
                <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:reportsVisible }"/>
            </div>
        </div>
        <!-- Collapsable content -->
        <div class="routa-collapse" :class="{ collapsed: reportsVisible }">
            <div class="col-12 show-print" v-if="reportsVisible">
                <div class="col-6 nopads chart-container">
                        <pie-chart
                            class="routa-pie dont-print p-4"
                            ref="pieHandledDanger"
                            :labels="pieLabels"
                            :colors="pieColors"
                            :data="pieData"
                            title="Käsitelty"
                        />
                        <img
                            class="print-only routa-pie-print"
                            id="pieHandledDangerImage"
                            alt="danger-handled pie chart"
                        />
                </div>

                <div class="col-6 nopads chart-container pt-4">
                    <bar-chart
                        class="routa-bars dont-print mt-4"
                        ref="barReports"
                        :labels="chartLabels"
                        :data="chartData"
                        :colors="chartColors"
                    />
                    <img
                        class="print-only routa-charts-print"
                        id="barDangerReportsImage"
                        alt="Danger reports image"
                    />
                </div>
            </div>
            <danger-report-list :results="dangerReports" class="my-2" @details="showDetails"/>
        </div>

        <base-modal
            v-if="detailsDangerReport"
            @close="detailsDangerReport = null"
            size="lg"
            hide-header
            hide-footer
        >
            <danger-report-details
                v-if="detailsDangerReport !== null"
                id="details"
                ref="details"
                :report="detailsDangerReport"
                :is-observer="isObserver"
                :user="user"
                @close="detailsDangerReport = null"
                @closeAndUpdate="closeAndUpdate"
            />
        </base-modal>
        <hr class="report-divider nopads"/>
    </div>
</template>


<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import DangerReportList from "@/components/dangerreports/DangerReportList";
import BarChart from "@/components/chart/BarChart";
import {dangerTypes} from '../mixins/DangerMixin'
import PieChart from "../chart/PieChart";
import DangerReportDetails from "../dangerreports/DangerReportDetails";
import BaseModal from "@/components/BaseModal";

export default {
    name: "contract-danger-reports",
    mixins: [timeUtils, restApi],
    components: {BaseModal, DangerReportDetails, PieChart, BarChart, DangerReportList},
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        user: {
            type: Object,
            default() {
                return null
            }
        },
        isObserver: Boolean,
    },
    data: function () {
        return {
            dangerReports: [],
            detailsDangerReport: null,
            reportsVisible: false,
            chartColors: ["#336677", '#faa633', "#992612"],
            loading: false,
            chartLabels: [
                this.$t('danger_report.event_type_list.unknown'),
                this.$t('danger_report.event_type_list.close_call'),
                this.$t('danger_report.event_type_list.accident'),
            ],
            pieLabels: [
                this.$t('danger_report.handled'),
                this.$t('danger_report.unhandled'),
            ],
            pieColors: ["#b7e89e", "#db7564"]
        }
    },
    computed: {
        pieData() {
            let handled = 0
            let unhandled = 0
            this.dangerReports.forEach(item => {
                if (item.handled) {
                    handled++
                } else {
                    unhandled++
                }
            })
            return [
                {value: handled},
                {value: unhandled}
            ]
        },
        chartData() {
            let other = 0
            let closeCalls = 0
            let accidents = 0
            this.dangerReports.forEach(item => {
                switch (item.event_type) {
                    case dangerTypes.ACCIDENT:
                        accidents++
                        break
                    case dangerTypes.CLOSE_CALL:
                        closeCalls++
                        break
                    case dangerTypes.OTHER:
                        other++
                        break
                }
            })
            return [
                {value: other},
                {value: closeCalls},
                {value: accidents}
            ]
        }
    },
    mounted() {
        this.fetchDangerReports()
    },
    watch: {
      searchParams () {
          this.fetchDangerReports()
      }
    },
    methods: {
        fetchDangerReports: function () {
            this.dangerReports = []
            if (this.searchParams) {
                let mappedParams = {
                    contract: this.searchParams.contract,
                    startTime: this.searchParams.dateFrom ? this.getDateIsoString(new Date(this.searchParams.dateFrom)) : null,
                    endTime: this.searchParams.dateTo ? this.getDateIsoString(new Date(this.searchParams.dateTo)) : null,
                }
                this.loading = true
                this.$emit('loading', true)
                this.restFetchParams(this.dangerReportUrl, mappedParams, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            if (response) {
                this.dangerReports = response.data
            }
            this.loading = false
            this.$emit('loading', false)
        },
        generateImages: function () {
            if (this.dangerReports && this.dangerReports.length > 0) {
                if (this.$refs.barReports) {
                    document.getElementById("barDangerReportsImage").src = this.$refs.barReports.getChartAsImage();
                }
                if (this.$refs.pieHandledDanger) {
                    document.getElementById("pieHandledDangerImage").src = this.$refs.pieHandledDanger.getChartAsImage();
                }
            }
        },
        showDetails(data) {
            this.detailsDangerReport = data
        },
        closeAndUpdate() {
            this.detailsDangerReport = null
            this.fetchDangerReports()
        }
    }
}
</script>
